import {preview} from './preview'
import type {PreviewReturn} from '../types'

export const titleImage = (props = {}): PreviewReturn =>
  preview({
    title: 'title',
    media: 'image',
    ...props,
  })
